import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { Client } from "../clients/clients";
import { Product, ProductOption } from "./products";

export class ClientTransaction {
    Id: number;
    ProductOptionId: number;
    ClientId: number;
    FixesTimes: number;
    IsForOperate: boolean;
    ApartmentSizeTypeTxt: string;
    ApartmentSize: number;
    ExistFileFormat: string;
    WantedFileFormat: string;
    TimeToGetProgramInDays: number;
    GetDWGFile: boolean;
    UniqIdForPay: string;
    IsUnsuccessMailSendToUser: boolean;
    UserComment: string;
    CouponCode: string;
    IsUserPayedForTransaction: boolean;
    TimeUserPayedForTransaction: string;
    FinalPrice: number;
    OriginalPrice: number;
    AdminComments: string;
    AdminCommentsObj: [{created: Date, data: string}];
    Created: string;
    Updated: string;
    Active: boolean;
  }


  export class ClientTransactionView {
    ClientTransaction: ClientTransaction;
    Client: Client;
    ProdName: string;
    UserAnswers: Array<UserAnswer>;
    captchaResponse: string;
    CouponId: number;
    DynamicOptionResponses: Array<DynamicOptionResponse>;
  
  }
  
  export class DynamicOptionResponse{
    Id: number;
    OptionId: number;
    DynamicOptionItemId: number;
    Label: string;
    Value: string;
    Price: number; 
    TransactionId: number;
    Created: string;
    Updated: string;
    Active: boolean;
  } 
  export class TransactionView {
    Transaction: ClientTransaction;
    Product: Product;
    ProductOption: ProductOption;
    UserAnswers: Array<UserAnswer>;
    DynamicOptionResponses: Array<DynamicOptionResponse>;
    Client: Client;
  }
  export class Question {
    Id: number;
    ProductOptionId: number;
    QuestionStr: string;
    Type: number;
    OptionsStr: string;
    Updated: string;
    Created: string;
    Active: boolean;
  }
  export class UserAnswer {
    Id: number;
    QuestionId: number;
    TransactionId: number;
    QuestionStr: string;
    UserAnswerStr: string;
    Updated: string;
    Created: string;
    Active: boolean;
  }
  export class ClientTransactionAndAnswerView {
    TransactionAndAnswerViewItems: Array<TransactionAndAnswerView>;
    Client: Client;
    ProdName: string;
    captchaResponse: string;
    CouponId: number;
    BasketSum: BasketSum;
    CouponCode: string;
  }
  export class TransactionAndAnswerView {
    Transaction: ClientTransaction;
    DynamicOptionResponses: Array<DynamicOptionResponse>;
    UserAnswers: Array<UserAnswer>;
    ProdName: string;
  }
  export class BasketSum {
    Id: number;
    Sum: number;
    UniqIdForPay: string;
    Updated: string;
    Created: string;
    Active: boolean;
  }
  export class TrnsPageView {
    numOfTrns: number;
    isActive: boolean;
    id: number;
    token: string;
  }